module.exports = new __parcel__URL__("seahorse-ios6.d1698305.webp").toString();